<template>
<div>
    <div class="main-header">
        <div class="container">
            <h2 class="main-header-text">
                {{showMap ? 'Find Partners' : (vModel.TransactionDetail.PaymentMethodId == 4 && !showMap) ? 'Booking Confirmation' : 'Transaction Confirmation' }}
            </h2>
        </div>
    </div>

    <div class="main-section mgt-40">
        <div class="container">

            <div class="main-card" v-if="vModel1">
                <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

                <div class="row">
                    <div class="col-lg-8" v-if="showMap">
                        <div class="form-card">
                            <div class="form-card-header">
                                <h3>Find eRemit Pay Partner Locations</h3>
                            </div>
                            <div class="form-card-forms">
                                <GoogleMapDetail></GoogleMapDetail>
                            </div>
                        </div>

                        <div class="submit-option">

                            <div class="right-option">
                                <button class="btn submit-righticon-btn" @click="onBackFromMap">
                                    <span class="btn-content">Back</span>
                                    <span class="right-icon">
                                        <i class="fas fa-angle-right"></i>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else class="col-lg-8">
                        <div  v-if="vModel.TransactionDetail.PaymentMethodId != 4">

                            <div class="transaction-detail text-center" v-if="vModel.Success">
                                <h2>Thank You!
                                    <br />Transaction Complete!
                                </h2>
                                <img src="/static/img/success.png" />

                            </div>

                            <div class="transaction-detail text-center" v-if="!vModel.Success">
                                <h2>
                                    {{vModel.Title}}
                                </h2>
                                <img v-if="vModel.Title != 'Transaction Pending'" src="/static/img/fail.png" />
                                <div class="mt-5">
                                    <span v-html="vModel.Message"></span>
                                </div>
                            </div>

                            <div class="submit-option">

                                <div class="right-option">
                                    <button class="btn submit-righticon-btn" @click="downloadInvoice" v-if="vModel.Success">
                                        <span class="btn-content">Download Tax Invoice</span>
                                        <span class="right-icon">
                                            <i class="fas fa-angle-right"></i>
                                        </span>
                                    </button>
                                    <router-link :to="'/dashboard'" class="btn submit-righticon-btn">
                                        <span class="btn-content">Home</span>
                                        <span class="right-icon">
                                            <i class="fas fa-angle-right"></i>
                                        </span></router-link>
                                </div>
                            </div>

                        </div>
                        <div v-if="vModel.TransactionDetail.PaymentMethodId == 4 && vModel.Success">
                            <div class="wrap-eremitpay-detail">
                                <EremitPayDetail :vModel="vModel2"></EremitPayDetail>
                            </div>
                            <div class="submit-option">

                                <div class="left-option">
                                    <button class="btn submit-lefticon-btn" @click="loadMap()">
                                        <span class="btn-content">Find A Partner</span>
                                        <span class="left-icon">
                                            <i class="fas fa-map-marker"></i>
                                        </span>
                                    </button>

                                </div>
                                <div class="right-option">
                                    <router-link :to="'/dashboard'" class="btn submit-righticon-btn">
                                        <span class="btn-content">Done</span>
                                        <span class="right-icon">
                                            <i class="fas fa-angle-right"></i>
                                        </span></router-link>
                                </div>
                            </div>

                        </div>
                        <div  v-if="vModel.TransactionDetail.PaymentMethodId == 4 && !vModel.Success">
                            <div class="transaction-detail text-center" style="padding: 25px;">
                                <h1 style='color: #cccccc;'><span v-html="vModel.Title"></span></h1><br />
                                <img src="/static/img/exclamation.png" v-if="vModel.Success" />
                                <img src="/static/img/fail.png" v-else />
                            </div>
                            <div class="transaction-detail text-center" style="padding: 25px;">

                                <p>Transaction Date: {{vModel.TransactionDetail.TransactionDate}}<br />
                                    Transaction Amount: MYR {{vModel.TransactionDetail.TransactionAmount}}<br />
                                    Order ID: {{vModel.TransactionDetail.OrderNumber}}<br />
                                    Booking Transaction ID: {{vModel.TransactionDetail.StagingOrderNumber || 'N/A'}}<br />
                                    Transaction Status: {{vModel.TransactionDetail.Status}}<br/>
                                    Failed Reason: {{vModel.TransactionDetail.FailedMessage}}</p>
                            </div>

                            <div class="submit-option">
                                <div class="right-option">
                                    <router-link :to="'/dashboard'" class="btn submit-righticon-btn">
                                        <span class="btn-content">Home</span>
                                        <span class="right-icon">
                                            <i class="fas fa-angle-right"></i>
                                        </span></router-link>
                                </div>
                            </div>

                        </div>
                        <!-- eo col-8 -->
                    </div>

                    <div class="col-lg-4">
                        <div class="sidebar">
                            <img src="/static/img/icons/arrow-down-indicator-white.png" alt="" class="sidebar-arrow" />

                            <h3 class="sidebar-header">Transfer Summary</h3>

                            <hr />

                            <div class="country-detail">
                                <img :src="'/static/img/flags/'+vModel1.Beneficiary.FlagCode+'.png'" alt="" />
                                <h4>{{vModel1.Beneficiary.FullName}}
                                    <br />
                                    <span class="country">{{vModel1.Beneficiary.Country}}</span>
                                </h4>
                            </div>

                            <hr />

                            <div class="personal-detail">
                                <ul>
                                    <li v-if="vModel1.PaymodeId == 101">
                                        <p>Payment Network : </p>
                                        <h4>Visa</h4>
                                    </li>
                                    <li v-else-if="vModel1.PaymodeId == 97 || vModel1.PaymodeId == 98">
                                        <p>Payment Network : </p>
                                        <h4>Western Union</h4>
                                    </li>
                                    <li v-else>
                                        <p>Payment Network : </p>
                                        <h4>Merchantrade</h4>
                                    </li>
                                    <li>
                                        <p>Payment Mode : </p>
                                        <h4>{{vModel1.PaymentModeName}}</h4>
                                    </li>
                                    <li v-if="vModel1.Beneficiary.CountryId == 56 &&  vModel1.PaymodeId == 21">
                                        <p>Payout Name : </p>
                                        <h4>{{vModel1.Beneficiary.BankOrAgent}}</h4>
                                    </li>
                                    <li v-if="vModel.TransactionDetail.ReceiverType != null && vModel.TransactionDetail.ReceiverType != ''">
                                        <p>Receiver Type : </p>
                                        <h4>{{vModel.TransactionDetail.ReceiverType}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 101">
                                        <p>Visa Card Number : </p>
                                        <h4><img src="/static/img/icons/visa_logo.png" style="width:50px; margin-right:5px;">{{vModel1.VisaCardNumber}}</h4>
                                    </li>
                                    <li>
                                        <p>
                                            {{
												vModel1.PaymodeId == 1 ? "Bank Account Holder Name" :
												(vModel1.PaymodeId == 2) ? "Beneficiary Name" :
												(vModel1.PaymodeId == 27 || PayoutModeId == 30 || PayoutModeId == 31 || PayoutModeId == 32 || PayoutModeId == 33) ? "Wallet Holder Name" :
												(vModel1.PaymodeId == 28 || vModel1.PaymodeId == 29) ? "eWallet Holder Name" :"Beneficiary Name"
                                            }}:
                                        </p>
                                        <h4 style="text-transform: uppercase;">{{vModel1.Beneficiary.FullName}}</h4>
                                    </li>
                                    <li v-if="vModel1.OnBehalfCustomerDetail.OnBehalfCustomerId">
                                        <p>Beneficial Owner :</p>
                                        <h4>{{vModel1.OnBehalfCustomerDetail.Name}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 1">
                                        <p>Bank Account Number : </p>
                                        <h4>{{vModel1.Beneficiary.BankAccount}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 1">
                                        <p>Bank Name :</p>
                                        <h4>{{vModel1.Beneficiary.Bank}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 24 || vModel1.PaymodeId == 28  || vModel1.PaymodeId == 29">
                                        <p>eWallet Type :</p>
                                        <h4>{{vModel1.PaymodeId == 24 ? vModel1.Beneficiary.Bank : vModel1.Beneficiary.WalletType}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 21">
                                        <p>Union Pay Card :</p>
                                        <h4>{{vModel1.Beneficiary.BankAccount}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 22">
                                        <p>Wallet Number :</p>
                                        <h4>{{vModel1.Beneficiary.BankAccount}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 24 || vModel1.PaymodeId==27 || vModel1.PaymodeId==28 || vModel1.PaymodeId==29">
                                        <p>eWallet Number :</p>
                                        <h4>{{vModel1.Beneficiary.BankAccount}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 2 || vModel1.PaymodeId == 34 || vModel1.PaymodeId == 35">
                                        <p>Agent :</p>
                                        <h4>{{vModel1.Beneficiary.BankOrAgent}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 23">
                                        <p>bKash Wallet No. : </p>
                                        <h4>{{vModel1.Beneficiary.BankAccount}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 26">
                                        <p>MCB Wallet No. : </p>
                                        <h4>{{vModel1.Beneficiary.BankAccount}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 25">
                                        <p>Wing Wallet No. : </p>
                                        <h4>{{vModel1.Beneficiary.BankAccount}}</h4>
                                    </li>
                                    <li v-if="vModel1.PaymodeId == 30">
                                        <p>Nagad Wallet Number : </p>
                                        <h4>{{vModel1.Beneficiary.BankAccount}}</h4>
                                    </li>

                                    <!-- <li v-if="vModel1.PaymodeId == 2">

    <p>Address :</p>

    <h4>{{vModel1.Beneficiary.Street}}, {{vModel1.Beneficiary.City}}</h4>

    </li> -->
                                </ul>
                            </div>

                            <hr />

                            <div class="amount-detail">
                                <ul>
                                    <li>Transfer Amount (MYR) :
                                        <span>{{vModel1.SendAmount}}</span>
                                    </li>
                                    <li>Exchange Rate :
                                        <span>{{vModel1.ExchangeRate}}</span>
                                    </li>
                                    <li>Receive Amount ({{vModel1.PayoutCurrency}}) :
                                        <span>{{vModel1.PayoutAmount}}</span>
                                    </li>
                                    <li>Service Charge (MYR) :
                                        <span>{{vModel1.TransferFee}}</span>
                                    </li>
                                    <li v-if="vModel1.ShowGST">GST Charge (MYR) :
                                        <span>{{vModel1.GST}}</span>
                                    </li>
                                    <li v-if="vModel1.ShowPromoDiscount">Promotion Discount (MYR) :
                                        <span>-{{vModel1.PromotionDiscount}}</span>
                                    </li>
                                </ul>
                                <div class="total-detail">
                                    <p>Total Transfer (MYR) :{{vModel1.DepositedAmount}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- eo row -->

            </div>
            <!-- eo main card -->

        </div>
        <!-- eo container -->
    </div>
    <!-- eo main section -->
</div>
</template>

<script>
import TransactionService from "../../services/transaction";
import commonService from "../../services/common";
import FileSaver from "file-saver";
import EremitPayDetail from "./eRemitPayDetail"
import GoogleMapDetail from "./partnermap"

export default {
    name: "transactionconfirmation",
    components: {
        EremitPayDetail,
        GoogleMapDetail
    },
    beforeRouteEnter(to, from, next) {
        commonService.removeStorage("transactionRefNo");
        var promises = [];
        var refno = to.params.txnrefno;

      promises.push(TransactionService.getConfirmation(refno), TransactionService.getDetail(refno));
      Promise.all(promises).then(response => {
        next(p => {
          p.vModel1 = response[1].body;
          p.vModel = response[0].body;
          p.vModel2.StagingExpiryDate = response[0].body.TransactionDetail.StagingExpiryDate;
          p.vModel2.StagingOrderNumber = response[0].body.TransactionDetail.StagingOrderNumber;
          p.vModel2.StagingBarCodeUrl = response[0].body.TransactionDetail.StagingBarCodeUrl;
          p.vModel2.StagingPaymentRemainingTime = response[0].body.TransactionDetail.StagingPaymentRemainingTime;
          p.vModel2.CurrentDateTime = response[0].body.TransactionDetail.CurrentDateTime;
        });
      });
    },
    data() {
      return {
        vModel1: null,
        vModel: {
          Success: false,
          Title: null,
          Message: null,
          TransactionDetail: {}
        },
        vModel2: {
          StagingExpiryDate: null,
          StagingOrderNumber: null,
          StagingBarCodeUrl: null,
          StagingPaymentRemainingTime: null
        },
        showMap: false
      };
    },
    methods: {
        getPayMode(val) {
            return TransactionService.getPaymentMode(val);
        },
        downloadInvoice: function () {
            this.$http
                .get("transaction/invoice/" + this.vModel1.TransactionRefNumber, {
                    responseType: "arraybuffer"
                })
                .then(response => {
                    var blob = new Blob([response.body], {
                        type: "application/pdf"
                    });
                    FileSaver.saveAs(blob, this.vModel1.TransactionRefNumber + ".pdf");
                });
        },
        loadMap() {
            this.showMap = true;
        },
        onBackFromMap() {
            this.showMap = false;
        }

    }
};
</script>
<style>
	.wrap-eremitpay-detail{
		padding-bottom: 170px;
	}

</style>
